module.exports = "/dist/822eba9c24e79985a0c0f9135787a470.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900italic.eot
// module id = 35
// module chunks = 0